import { useState } from "react"
import { useFetchGames,useFetchSubjects,useFetchClassrooms } from "../../hooks/homepage/useHomepage"

const useHomepageLogic = () => {
    const [searchTerm, setSearchTerm] = useState("")
    const [classroom_id, setClassroom_id] = useState("")
    const [subject_id, setSubject_id] = useState("")
    const [topic_id, setTopic_id] = useState("")
    const [is_popular, setIs_popular] = useState(false)
    const subjectsAPI=useFetchSubjects()
    const classroomsAPI= useFetchClassrooms()
const fetchGames= useFetchGames({pageNumber:1, pageSize:1000, searchTerm, classroom_id, subject_id,topic_id, is_popular})
return {fetchGames, setSearchTerm, subjectsAPI,classroomsAPI, classroom_id, setClassroom_id, subject_id, setSubject_id, topic_id, setTopic_id, is_popular, setIs_popular}
}
export default useHomepageLogic